@if (showBackgroundContainer) {
    <ms-header [titleIcon]="titleIcon" [backgroundContainerConfig]="backgroundContainerConfig" [globalLinkConfig]="globalLinkConfig" />
}

@if (tiles.length) {
    <ms-scroll-adapter size="medium" [scrollSpeed]="scrollSpeed">
        <ul class="center" [ngClass]="getListCardClass()">
            @for (tile of tiles; track trackOutrightTile($index, tile)) {
                <li class="marquee-card card card-bordered" [ngClass]="getMarqueeCardImgClass()">
                    <ms-outrights-marquee-card
                        [tile]="tile"
                        [textColor]="backgroundContainerConfig.textColor"
                        [outrightOptionGroup]="outrightOptionGroup"
                        [event]="event"
                        [backgroundImage]="backgroundImage"
                        [globalLink]="globalLink" />
                </li>
            }
        </ul>
    </ms-scroll-adapter>
}
